module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/2@2x_949148eb2a17b89b27f3f1d5ded5b255.png";